var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"pt-4 pb-4 primary white--text"},[_c('img',{staticClass:"wordmark",attrs:{"src":"img/sir-wordmark.svg"}}),_c('v-spacer'),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"img/sir-logo.svg"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }